(function () {
  var zoomActive = null;
  var BASE_SCALE = 2;
  var MAX_EXTRA = 2.5;

  function dist(a, b) {
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function closeOtherActive(exceptContainer) {
    if (zoomActive && zoomActive !== exceptContainer) {
      var prevImg = zoomActive.querySelector('.zoomable-image');
      zoomActive.classList.remove('zoom-active');
      if (prevImg) { prevImg.style.transform = ''; prevImg.style.transformOrigin = ''; }
      zoomActive = null;
    }
  }

  function setupContainer(container) {
    var image = container.querySelector('.zoomable-image');
    if (!image) return;

    var extra = 1;
    var hiResLoaded = false;

    var scale = 1;
    var panX = 0;
    var panY = 0;
    var pinch = null;
    var drag = null;
    var tap = null;

    function loadHiRes() {
      if (hiResLoaded) return;
      hiResLoaded = true;
      var src = image.dataset.zoomSrc;
      if (!src || src === image.src) return;
      var pre = new Image();
      pre.onload = function () { image.src = src; };
      pre.src = src;
    }

    function setOrigin(clientX, clientY) {
      var rect = container.getBoundingClientRect();
      var x = ((clientX - rect.left) / rect.width) * 100;
      var y = ((clientY - rect.top) / rect.height) * 100;
      if (x > 0 && x < 100 && y > 0 && y < 100) {
        image.style.transformOrigin = x + '% ' + y + '%';
      }
    }

    function applyZoom() {
      image.style.transform = 'scale(' + (BASE_SCALE * extra) + ')';
    }

    function activate(clientX, clientY) {
      closeOtherActive(container);
      container.classList.add('zoom-active');
      zoomActive = container;
      extra = 1;
      if (clientX !== undefined) setOrigin(clientX, clientY);
      applyZoom();
      loadHiRes();
    }

    function deactivate() {
      container.classList.remove('zoom-active');
      image.style.transform = '';
      image.style.transformOrigin = '';
      extra = 1;
      if (zoomActive === container) zoomActive = null;
    }

    container.addEventListener('click', function (event) {
      if (!container.classList.contains('zoom-active')) {
        activate(event.clientX, event.clientY);
      } else {
        deactivate();
      }
    });

    container.addEventListener('mousemove', function (event) {
      if (container.classList.contains('zoom-active')) setOrigin(event.clientX, event.clientY);
    });

    container.addEventListener('wheel', function (event) {
      if (!container.classList.contains('zoom-active')) return;
      event.preventDefault();
      event.stopPropagation();
      var delta = event.deltaY > 0 ? -0.3 : 0.3;
      extra = Math.max(1, Math.min(MAX_EXTRA, extra + delta));
      applyZoom();
    }, { passive: false });

    function relPoint(clientX, clientY) {
      var rect = container.getBoundingClientRect();
      return { x: clientX - rect.left, y: clientY - rect.top };
    }

    function clampPan() {
      var minX = container.clientWidth * (1 - scale);
      var minY = container.clientHeight * (1 - scale);
      panX = Math.min(0, Math.max(minX, panX));
      panY = Math.min(0, Math.max(minY, panY));
    }

    function applyTouchTransform() {
      image.style.transformOrigin = '0 0';
      image.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    }

    function touchActivate(clientX, clientY) {
      closeOtherActive(container);
      var p = relPoint(clientX, clientY);
      scale = BASE_SCALE;
      panX = p.x - p.x * scale;
      panY = p.y - p.y * scale;
      clampPan();
      container.classList.add('zoom-active');
      zoomActive = container;
      applyTouchTransform();
      loadHiRes();
    }

    function touchDeactivate() {
      deactivate();
      scale = 1;
      panX = 0;
      panY = 0;
    }

    container.addEventListener('touchstart', function (event) {
      if (event.touches.length === 1) {
        var t = event.touches[0];
        tap = { x: t.clientX, y: t.clientY, t: Date.now(), moved: false };
        drag = { lastX: t.clientX, lastY: t.clientY };
      } else if (event.touches.length === 2) {
        var t0 = event.touches[0];
        var t1 = event.touches[1];
        event.stopPropagation();
        pinch = { startDist: dist(t0, t1), startScale: scale };
        tap = null;
        drag = null;
        container.style.touchAction = 'none';
        if (!container.classList.contains('zoom-active')) {
          closeOtherActive(container);
          container.classList.add('zoom-active');
          zoomActive = container;
          loadHiRes();
        }
      }
    }, { passive: true });

    container.addEventListener('touchmove', function (event) {
      if (pinch && event.touches.length === 2) {
        event.preventDefault();
        event.stopPropagation();
        var pt0 = event.touches[0];
        var pt1 = event.touches[1];
        var nd = dist(pt0, pt1);
        var maxScaleAbs = BASE_SCALE * MAX_EXTRA;
        var newScale = Math.min(maxScaleAbs, Math.max(1, pinch.startScale * (nd / pinch.startDist)));
        var mid = relPoint((pt0.clientX + pt1.clientX) / 2, (pt0.clientY + pt1.clientY) / 2);
        var contentX = (mid.x - panX) / scale;
        var contentY = (mid.y - panY) / scale;
        scale = newScale;
        panX = mid.x - contentX * scale;
        panY = mid.y - contentY * scale;
        clampPan();
        applyTouchTransform();
        return;
      }
      if (tap && event.touches.length === 1) {
        var t = event.touches[0];
        var dx = t.clientX - tap.x;
        var dy = t.clientY - tap.y;
        if (Math.sqrt(dx * dx + dy * dy) > 10) tap.moved = true;
        if (container.classList.contains('zoom-active') && drag) {
          event.preventDefault();
          event.stopPropagation();
          panX += t.clientX - drag.lastX;
          panY += t.clientY - drag.lastY;
          clampPan();
          drag.lastX = t.clientX;
          drag.lastY = t.clientY;
          applyTouchTransform();
        }
      }
    }, { passive: false });

    container.addEventListener('touchend', function (event) {
      if (pinch) {
        if (event.touches.length < 2) {
          if (scale <= 1.05) touchDeactivate();
          pinch = null;
        }
      } else if (tap) {
        event.preventDefault();
        var elapsed = Date.now() - tap.t;
        if (!tap.moved && elapsed < 300) {
          if (!container.classList.contains('zoom-active')) {
            touchActivate(tap.x, tap.y);
          } else {
            touchDeactivate();
          }
        }
      }
      if (event.touches.length === 0) {
        tap = null;
        drag = null;
        container.style.touchAction = '';
      }
    }, { passive: false });
  }

  function initZoomEngine() {
    document.querySelectorAll('.zoomable-container').forEach(function (container) {
      if (container.dataset.zoomInit === 'true') return;
      container.dataset.zoomInit = 'true';
      setupContainer(container);
    });

    if (!window.__zoomDocClickBound) {
      window.__zoomDocClickBound = true;
      document.addEventListener('click', function (event) {
        if (zoomActive && !event.target.closest('.zoomable-container')) {
          closeOtherActive(null);
        }
      });
    }
  }

  initZoomEngine();
  document.addEventListener('updateImageZoom:init', initZoomEngine);
})();
